module.exports = __webpack_public_path__ + "img/codepen-brands.1a1b9c73.svg";